<div class="home-container">
    <h1 translate>WELCOME_H1</h1>
    <p><span translate>WELCOME_P</span>: <span class="fw-bold">{{isAdmin ? 'Admin' : 'Not Admin'}}</span></p>
</div>
